import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { DatePickerComponent, DateRangeCx } from "../../../Component/Custom";
import { ErrorMessages } from "../../../Constants";
import monthsList from "../../../Constants/DATA/monthsList";
import { getEJ2CalenderDateFormat, getFormattedDate } from "../../../Utils";
import { betweenDays } from "../../../Utils/dates";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class OneTimeReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthList: monthsList,
      typeList: [
        { displayvalue: "1", displayname: "Year Month" },
        { displayvalue: "2", displayname: "Year" },
        { displayvalue: "3", displayname: "Date Range" },
        { displayvalue: "4", displayname: "Upto Today" },
        { displayvalue: "5", displayname: "Select Cycle" },
      ],
      sendDate: "0",
      RangeList: [],
      date: false,
      month: false,
      year: false,
      sendReport: false,
      sendDateData: null,
    };
    this.setsendDate = this.setsendDate.bind(this);
    this.getChild = this.getChild.bind(this);
    this.monthOnSelect = this.monthOnSelect.bind(this);
    this.yearOnSelect = this.yearOnSelect.bind(this);
    this.getLeaveCycleIds = this.getLeaveCycleIds.bind(this);
  }

  componentDidMount() {
    // this.rangeList();
    if (this.props.selectSubReport) {
      if (this.props.selectSubReport.reportcatagoryid == 4) {
        this.getPayrollCycles();
      } else if (this.props.selectSubReport.reportcatagoryid == 5) {
        this.getExpenseCycleData();
      } else if (this.props.selectSubReport.reportcatagoryid == 7) {
        this.getPerformCycles();
      } else {
        this.getLeaveCycleIds();
      }
    }
    if (this.props.updateId) {
      // this.setState({ sendDate : })
    }
  }

  getExpenseCycleData() {
    instance
      .get("expense/expensecycle")
      .then((result) => {
        this.setState({
          monthcutoffday: get(result, "data.result[0].monthcutoffday", ""),
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getPayrollCycles() {
    instance
      .get(`payroll/getpayrollcycle`)
      .then((resp) => {
        this.setState({
          subscriptionleavecycle: resp.data.result.map((x) => ({
            ...x,
            displayvalue: x.payrollcycledurationid,
          })),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getPerformCycles() {
    instance
      .get(`perform/getsubperformcycle`)
      .then((resp) => {
        this.setState({
          subscriptionleavecycle: resp.data.result.map((x) => ({
            ...x,
            displayvalue: x.performcycledurationid,
          })),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getLeaveCycleIds() {
    instance.get("leaves/subscriptionleavecycle").then((resp) => {
      this.setState({ subscriptionleavecycle: resp.data.result });
    });
  }

  onDateRangeChange = ({ startdate = null, enddate = null }) => {
    try {
      if (
        startdate &&
        enddate &&
        betweenDays({
          startdate: moment(startdate),
          enddate: moment(enddate),
        }) > (this.props.selectSubReport.value == 211 ? 365 : 90)
      ) {
        this.props.enqueueSnackbar(
          this.props.selectSubReport.value == 211
            ? ErrorMessages.E1520
            : ErrorMessages.E1250,
        { variant: "error" },
        );
        startdate = null;
        enddate = null;
      }
      this.props._setState("fromDate", startdate);
      this.props._setState("toDate", enddate);
    } catch (err) {}
  };

  monthOnSelect = (val) => {
    try {
      if (
        this.props.selectSubReport.reportcatagoryid == 5 &&
        this.state.monthcutoffday
      ) {
        const enddate =
          this.state.monthcutoffday > 27
            ? moment(val.value).endOf("month").format("YYYY-MM-DD")
            : `${moment(val.value).format("YYYY-MM")}-${
                this.state.monthcutoffday
              }`;
        const startdate =
          this.state.monthcutoffday > 27
            ? moment(val.value).startOf("month").format("YYYY-MM-DD")
            : `${moment(
                `${moment(val.value).format("YYYY-MM")}-${
                  this.state.monthcutoffday
                }`,
                "YYYY-MM-DD",
              )
                .subtract(1, "months")
                .add(1, "day")
                .format("YYYY-MM-DD")}`;
        this.props._setState(
          "fromDate",
          val.value ? moment(startdate, "YYYY-MM-DD") : null,
        );
        this.props._setState(
          "toDate",
          val.value ? moment(enddate, "YYYY-MM-DD") : null,
        );
      } else {
        this.props._setState(
          "fromDate",
          val.value ? moment(val.value).startOf("month") : null,
        );
        this.props._setState(
          "toDate",
          val.value ? moment(val.value).endOf("month") : null,
        );
      }
    } catch (err) {}
  };

  yearOnSelect = (val) => {
    try {
      this.props._setState(
        "fromDate",
        val.value ? moment(val.value).startOf("year") : val.value,
      );
      this.props._setState(
        "toDate",
        val.value ? moment(val.value).endOf("year") : val.value,
      );
    } catch (err) {
      console.log("err:  yearOnSelect", err);
    }
    // this.setState({ selectYear: val });
  };

  setsendDate = (val) => {
    try {
      if (val.displayvalue == 4) {
        this.props._setState("fromDate", new Date());
        this.props._setState("toDate", new Date());
      }

      this.setState({
        sendDate: val.displayvalue,
        sendDateData: this.state.typeList.find(
          (x) => val.displayvalue == x.displayvalue,
        ),
      });
      this.props._setState("sendDate", val.displayvalue);
    } catch (err) {
      console.log("err:  setsendDate", err);
    }
  };

  getFromDate = () => {
    try {
      const { fromDate, toDate } = this.props;
      if (
        this.props.selectSubReport.reportcatagoryid == 5 &&
        this.state.monthcutoffday
      ) {
        const dateResult = toDate || null;
        return dateResult;
      } else {
        const dateResult = fromDate || null;
        return dateResult;
      }
    } catch (err) {
      console.log("err:  getFromDate", err);
      return "";
    }
    // return getFormattedDate(fromDate);
  };

  getChild = (val) => {
    try {
      switch (val) {
        case "1": // Year Month
          return (
            <div className={this.state.sendDate != 1 && "display-none"}>
              <DatePickerComponent
                start="Year"
                depth="Year"
                allowEdit={false}
                onClick={() => this.dateObj2 && this.dateObj1.show()}
                ref={(d) => (this.dateObj1 = d)}
                border="1px solid #166ab3 !important"
                format={getEJ2CalenderDateFormat("yyyy, MMM")}
                width="360px"
                change={this.monthOnSelect}
                value={this.getFromDate()}
              />
            </div>
          );
        case "2": // year
          return (
            <div className={this.state.sendDate != 2 && "display-none"}>
              <DatePickerComponent
                start="Decade"
                depth="Decade"
                allowEdit={false}
                onClick={() => this.dateObj2 && this.dateObj2.show()}
                ref={(d) => (this.dateObj2 = d)}
                border="1px solid #166ab3 !important"
                format={getEJ2CalenderDateFormat("yyyy")}
                width="360px"
                change={this.yearOnSelect}
                value={this.getFromDate()}
              />
            </div>
          );
        case "3": // date range
          return (
            <div className={this.state.sendDate != 3 && "display-none"}>
              <DateRangeCx
                startdate={get(this.props, "fromDate", "")}
                enddate={get(this.props, "toDate", "")}
                onClose={(e) => this.onDateRangeChange(e)}
              />
            </div>
          );
        case "4": // upto today
          return (
            <div className={this.state.sendDate != 4 && "display-none"}>
              <DatePickerComponent
                start="Decade"
                allowEdit={false}
                border="1px solid #166ab3 !important"
                format={getEJ2CalenderDateFormat()}
                width="360px"
                max={new Date()}
                change={(e) => {
                  this.props._setState("fromDate", e.value);
                  this.props._setState("toDate", new Date());
                }}
                value={this.getFromDate()}
              />
            </div>
          );
        case "5": {
          // leave cycle
          const val1 =
            this.props.selectSubReport.reportcatagoryid == 4
              ? get(this.state, "subscriptionleavecycle", []).find(
                  (x) => x.payrollcyclestartdate == this.props.fromDate,
                )
              : this.props.selectSubReport.reportcatagoryid == 7
                ? get(this.state, "subscriptionleavecycle", []).find(
                  (x) => x.cyclestartdate == this.props.fromDate,
                )
                : get(this.state, "subscriptionleavecycle", []).find(
                    (x) => x.leavecyclestartdate == this.props.fromDate,
                  );
          return (
            <div className={this.state.sendDate != 5 && "display-none"}>
              <Select
                className="form-control width360"
                autoFocus
                placeholder="Select cycle"
                options={get(this.state, "subscriptionleavecycle", [])}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                onChange={(value) => {
                  if (this.props.selectSubReport.reportcatagoryid == 4) {
                    this.props._setState("fromDate", value.payrollcyclestartdate);
                    this.props._setState("toDate", value.payrollcycleenddate);
                  } else if (this.props.selectSubReport.reportcatagoryid == 7) {
                    this.props._setState("fromDate", value.cyclestartdate);
                    this.props._setState("toDate", value.cycleenddate);
                  } else {
                    this.props._setState("fromDate", value.leavecyclestartdate);
                    this.props._setState("toDate", value.leavecycleenddate);
                  }
                }}
                value={val1}
              />
            </div>
          );
        }
        default:
          return null;
      }
    } catch (err) {
      return null;
    }
  };

  render() {
    const { selectSubReport } = this.props;
    const language = this.props.Language.reportrobo;
    const { sendDate, typeList } = this.state;

    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {this.state.sendDate != 4 && (
            <p className="add-label-active">
              Date Range Type:
              <strong>
                {this.props.toDate &&
                  ` ${
                    this.props.selectSubReport.reportcatagoryid == 5 &&
                    this.state.monthcutoffday
                      ? getFormattedDate(this.props.fromDate)
                      : getFormattedDate(this.getFromDate())
                  } - ${getFormattedDate(this.props.toDate)}`}
              </strong>
            </p>
          )}
          <div className="">
            <RadioGroup aria-label="service" name="service" value={sendDate}>
              {get(selectSubReport, "daterangeids", "").indexOf("1") != -1 && (
                <div>
                  <FormControlLabel
                    onClick={() => this.setsendDate(typeList[0])}
                    value="1"
                    control={<Radio color="primary" checked={sendDate == 1} />}
                    label="Year Month"
                    style={{ height: 40 }}
                  />
                  <div className={this.state.sendDate != 1 && "display-none"}>
                    <DatePickerComponent
                      start="Year"
                      depth="Year"
                      allowEdit={false}
                      onClick={() => this.dateObj2 && this.dateObj1.show()}
                      ref={(d) => (this.dateObj1 = d)}
                      border="1px solid #166ab3 !important"
                      format={getEJ2CalenderDateFormat("yyyy, MMM")}
                      width="360px"
                      change={this.monthOnSelect}
                      value={this.getFromDate()}
                    />
                  </div>
                </div>
              )}

              {get(selectSubReport, "daterangeids", "").indexOf("2") != -1 && (
                <div>
                  <FormControlLabel
                    onClick={() => this.setsendDate(typeList[1])}
                    value="2"
                    control={<Radio color="primary" checked={sendDate == 2} />}
                    label="Year"
                    style={{ height: 40 }}
                  />
                  <div className={this.state.sendDate != 2 && "display-none"}>
                    <DatePickerComponent
                      start="Decade"
                      depth="Decade"
                      allowEdit={false}
                      onClick={() => this.dateObj2 && this.dateObj2.show()}
                      ref={(d) => (this.dateObj2 = d)}
                      border="1px solid #166ab3 !important"
                      format={getEJ2CalenderDateFormat("yyyy")}
                      width="360px"
                      change={this.yearOnSelect}
                      value={this.getFromDate()}
                    />
                  </div>
                </div>
              )}

              {get(selectSubReport, "daterangeids", "").indexOf("3") != -1 && (
                <div>
                  <FormControlLabel
                    onClick={() => this.setsendDate(typeList[2])}
                    value={"3"}
                    control={<Radio color="primary" checked={sendDate == 3} />}
                    label={"Date Range"}
                    style={{ height: 40 }}
                  />
                  <div className={this.state.sendDate != 3 && "display-none"}>
                    <DateRangeCx
                      startdate={get(this.props, "fromDate", "")}
                      enddate={get(this.props, "toDate", "")}
                      onClose={(e) => this.onDateRangeChange(e)}
                    />
                  </div>
                </div>
              )}
              {get(selectSubReport, "daterangeids", "").indexOf("4") != -1 && (
                <div style={{ position: "relative" }}>
                  <FormControlLabel
                    onClick={() => this.setsendDate(typeList[3])}
                    value="4"
                    control={<Radio color="primary" checked={sendDate == 4} />}
                    label="Upto today"
                    style={{ height: 40 }}
                  />
                  <div className={this.state.sendDate != 4 && "display-none"}>
                    <div className="section-header-outer margin-bottom-10">
                      <span className="section-header-extra-small">
                        Note: from below date to today
                      </span>
                    </div>
                    <DatePickerComponent
                      placeholder="from"
                      start="Decade"
                      allowEdit={false}
                      border="1px solid #166ab3 !important"
                      format={getEJ2CalenderDateFormat()}
                      width="360px"
                      disabled={true}
                      max={new Date()}
                      change={(e) => {
                        this.props._setState("fromDate", e.value);
                        this.props._setState("toDate", new Date());
                      }}
                      value={new Date()}
                    />
                  </div>
                </div>
              )}

              {get(selectSubReport, "daterangeids", "").indexOf("5") != -1 && (
                <div>
                  <FormControlLabel
                    onClick={() => this.setsendDate(typeList[4])}
                    value="5"
                    control={<Radio color="primary" checked={sendDate == 5} />}
                    label="Select Cycle"
                    style={{ height: 40 }}
                  />
                  {this.getChild("5")}
                </div>
              )}
            </RadioGroup>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

OneTimeReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(OneTimeReport)));
